import { CustomHeaderComponent } from '../../components/custom-header/custom-header.component';
import { MapperTypesComponent } from '../../components/mapper-types/mapper-types.component';
import { MAPPER_CONFIGS } from '../../components/mapper-types/model/mappers.model';
import { INTEGRATIONS } from '../global-configuration.constant';
import { DefaultSettingLoaderService } from '../../service/default-setting-loader.service';
import { DocumentTypesLoaderService } from '../../service/document-types.loader.service';
import { LoanReasonsLoaderService } from '../../service/loan-reasons-loader.service';
import { LoanTypesLoaderService } from '../../service/loan-types-loader.service';
import { OccupancyTypesLoaderService } from '../../service/occupancy-types-loader.service';
import { PropertyTypesLoaderService } from '../../service/property-types-loader.service';
import { FNCDefaultSettingComponent } from '../../fnc-mapper-types/fnc-default-setting/fnc-default-setting.component';

const FNC_MAPPER_CHILDREN = [
	{
		path: 'property-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.PROPERTY_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Property Types'
			},
		},
		canActivate: [PropertyTypesLoaderService]
	},
	{
		path: 'loan-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.LOAN_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Loan Types'
			},
		},
		canActivate: [LoanTypesLoaderService]
	},
	{
		path: 'loan-reasons',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.LOAN_REASONS,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Loan Reasons'
			}
		},
		canActivate: [LoanReasonsLoaderService]
	},
	{
		path: 'occupancy-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.OCCUPANCY_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Occupancy Types'
			}
		},
		canActivate: [OccupancyTypesLoaderService]
	},
	{
		path: 'on-hold-reasons',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.ONHOLD_REASONS,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'OnHold Reasons'
			}
		}
	},
	{
		path: 'document-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.FNC,
			config: MAPPER_CONFIGS.DOCUMENT_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Document Types'
			}
        },
        canActivate: [DocumentTypesLoaderService]
    },
    {
        path: 'default-settings',
        component: FNCDefaultSettingComponent,
        data: {
            subComponentShow: false,
            breadcrumbComponent: CustomHeaderComponent
        },
        canActivate: [DefaultSettingLoaderService]
    }
]

export const FNC_MAPPER = [
	{
		path: 'fnc-mapper-types',
		pathMatch: 'prefix',
		children: FNC_MAPPER_CHILDREN
	}
]